import React, { useState, ChangeEvent } from 'react';
import styles from './style.module.css';
import Typography from '../../../../components/Typography/Typography';
import FlatButtons from '../../../../components/FlatButton/FlatButton';
import { ModalClose, StoreCloudUpload } from '../../../../assets/svgs';
import { Link, useParams } from 'react-router-dom';

interface Product {
  id: string;
  name: string;
  description: string;
  category: string;
  image: string;
  quantity: number;
}

interface AddProductModalProps {
  // isOpen: boolean;
  // onClose: () => void;
  // onAddProduct: (product: Product) => void;
}

export const EditProduct: React.FC<AddProductModalProps> = ({
  // isOpen,
  // onClose,
  // onAddProduct
}) => {
  const { id } = useParams<{ id: string }>()

  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    category: 'Clothing',
    quantity: 50
  });

  const handleImageUpload = (event: ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setSelectedImage(e.target?.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleInputChange = (field: string, value: string | number): void => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = (): void => {
    if (selectedImage && formData.name.trim()) {
      const newProduct: Product = {
        id: Date.now().toString(),
        name: formData.name,
        description: formData.description,
        category: formData.category,
        image: selectedImage,
        quantity: formData.quantity
      };
      // onAddProduct(newProduct);
      handleClose();
    }
  };

  const handleClose = (): void => {
    setSelectedImage(null);
    setFormData({
      name: '',
      description: '',
      category: 'Clothing',
      quantity: 50
    });
    // onClose();
  };

  // if (!isOpen) return null;

  return (
    // <div className={styles.modalOverlay}>
    <div className={styles.modalContent}>

      <div className={styles.navContainer}>

        <Link className={styles.navBtn} to={`/products`}>
          <Typography>
            Product List
          </Typography>
        </Link>

        <div className={styles.arrowContainer}>

          <div className={styles.arrowRight}></div>

        </div>

        <Link className={styles.navBtn} to={`/view/${id}`}>
          <Typography
          // variant='heading6'
          >
            Product Details
          </Typography>
        </Link>

        <div className={styles.arrowContainer}>

          <div className={styles.arrowRight}></div>

        </div>

        <Link className={styles.navBtn} to={``}>
          <Typography
            variant='heading6'
          >
            Edit Product
          </Typography>
        </Link>

      </div>



      <div className={styles.modalHeader}>
        <Typography
          variant='heading5'
          fontFamily='satoshi'
          weight='bold'
          className={styles.modalTitle}>
          Product Details
        </Typography>

        {/* <FlatButtons className={styles.closeButton} onClick={handleClose}>
                    <img
                        src={ModalClose}
                        alt='Close icon'
                    />
                </FlatButtons> */}
      </div>

      <div className={styles.modalBody}>
        <div className={styles.imageSection}>
          <label htmlFor='product-image-upload' className={styles.sectionLabel}>
            <Typography
              variant='heading5'
              fontFamily='satoshi'
              weight='bold'
              className={styles.sectionLabelText}>
              Product Image
            </Typography>
          </label>

          {!selectedImage ? (
            <div className={styles.uploadArea}>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageUpload}
                className={styles.fileInput}
                id="product-image-upload"
              />
              <label htmlFor="product-image-upload" className={styles.uploadLabel}>
                <div className={styles.uploadIcon}>
                  <img
                    src={StoreCloudUpload}
                    alt='store upload icon'
                  />
                </div>
                <Typography
                  variant='bodyRegular'
                  fontFamily='satoshi'
                  weight='regular'
                  className={styles.uploadText}>
                  Drag and drop files here
                </Typography>
                <Typography
                  variant='bodyRegular'
                  fontFamily='satoshi'
                  weight='regular'
                  className={styles.uploadSubtext}>
                  or
                </Typography>
                <FlatButtons
                  type="button"
                  className={styles.browseButton}
                >
                  <Typography
                    variant='buttonText'
                    fontFamily='satoshi'
                    weight='regular'
                    size='base'
                    className={styles.browseButtonText}>
                    Browse
                  </Typography>
                </FlatButtons>
                <Typography
                  variant='bodyRegular'
                  fontFamily='satoshi'
                  weight='regular'
                  className={styles.supportedFormats}>
                  Supported: WebP, glTF, GLB, FBX
                </Typography>
              </label>
            </div>
          ) : (
            <div className={styles.imagePreview}>
              <img
                src={selectedImage}
                alt="Product preview"
                className={styles.previewImage} />
            </div>
          )}

          <Typography
            variant='bodyRegular'
            fontFamily='satoshi'
            weight='regular'
            className={styles.convertText}>
            Don't have a 3D Model of your product?
            <span className={styles.convertLink}> Convert Image here</span>
          </Typography>
        </div>

        <div className={styles.formSection}>
          <div className={styles.formRow}>
            <div className={styles.formGroup1}>
              <label htmlFor='name' className={styles.formLabel}>
                <Typography
                  variant='heading4'
                  fontFamily='satoshi'
                  weight='bold'
                  size='base'
                  className={styles.labelText}>
                  General Information
                </Typography>
              </label>
              <div className={styles.inputGroup}>
                <label htmlFor='name'
                  className={styles.inputLabel}>
                  <Typography
                    variant='bodyRegular'
                    fontFamily='satoshi'
                    weight='regular'
                    size='base'
                    className={styles.labelText}>
                    Product Name
                  </Typography>
                </label>
                <input
                  type="text"
                  id='name'
                  placeholder="Highland Mid Calf Boots"
                  value={formData.name}
                  onChange={(e) => handleInputChange('name', e.target.value)}
                  className={styles.formInput}
                />
              </div>
              <div className={styles.inputGroup}>
                <label htmlFor='description' className={styles.inputLabel}>
                  <Typography
                    variant='bodyRegular'
                    fontFamily='satoshi'
                    weight='regular'
                    size='base'
                    className={styles.labelText}>
                    Product Description
                  </Typography>
                </label>
                <textarea
                  id='description'
                  placeholder="Enter product description..."
                  value={formData.description}
                  onChange={(e) => handleInputChange('description', e.target.value)}
                  className={styles.formTextarea}
                  rows={4}
                />
              </div>
            </div>

            <div className={styles.formGroup2}>
              <label htmlFor='category' className={styles.formLabel2}>
                <Typography
                  variant='heading4'
                  fontFamily='satoshi'
                  weight='bold'
                  size='base'
                  className={styles.labelText}>
                  Category Information
                </Typography>
              </label>
              <Typography
                variant='bodyRegular'
                fontFamily='satoshi'
                weight='regular'
                className={styles.categoryHelp}>
                First Select Product category to get category details
              </Typography>
              <div className={styles.inputGroup2}>
                <label htmlFor='category' className={styles.inputLabel}>
                  <Typography
                    variant='bodyRegular'
                    fontFamily='satoshi'
                    weight='regular'
                    size='base'
                    className={styles.labelText}>
                    Add Product Category
                  </Typography>
                </label>
                <select
                  title='category section'
                  id='category'
                  value={formData.category}
                  onChange={(e) => handleInputChange('category', e.target.value)}
                  className={styles.formSelect}
                >
                  <option value="Clothing">Clothing</option>
                  <option value="Electronics">Electronics</option>
                  <option value="Home">Home & Garden</option>
                  <option value="Beauty">Beauty & Personal Care</option>
                  <option value="Sports">Sports & Outdoors</option>
                  <option value="Books">Books & Media</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.modalFooter}>
        <div className={styles.buttonGroup}>
          <FlatButtons
            className={styles.addButton}
            onClick={handleSubmit}
            disabled={!selectedImage || !formData.name.trim()}
          >
            <Typography
              variant='buttonText'
              fontFamily='satoshi'
              weight='regular'
              size='base'
              className={styles.storeNameText}>
              Add Product
            </Typography>
          </FlatButtons>
        </div>
      </div>
    </div>
    // </div>
  );
};
